<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <el-form ref="form" :model="form" :label-width="labelWidth">
      <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="c.viewMode" :config="c" :options="c.options"
        :inputValue="form[c.keyName]" @onChange="onChange" />

      <template v-if="detail.applystate == 1">
        <FormItem v-for="(c, i) in formCtrl1" :key="'form1Item' + i" :viewMode="c.viewMode" :config="c"
          :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
      </template>

      <template v-if="detail.position == 1">
        <FormItem v-for="(c, i) in formCtrl2" :key="'form2Item' + i" :viewMode="c.viewMode" :config="c"
          :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
      </template>
    </el-form>

    <div class="btns">
      <el-button type="primary" @click="onSubmit">通 过</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../mixin/detail";

export default {
  name: "FixdDtail",
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'applypc',
      getDataUrl: 'applygo',
      breadcrumb: [
        { name: "事项审核", path: `/fix/list` },
        { name: "事项列表", path: `/fix/list` },
        { name: "审核" },
      ],
      formCtrl: [
        {
          label: "代办事项标题",
          keyName: "title",
          err: "请填写代办事项标题",
          type: "text",
        },
        {
          label: "详细内容",
          keyName: "description",
          err: "请填写详细内容",
          type: "text",
        },
      ],
      formCtrl1: [
        {
          label: "姓名",
          keyName: "applyname",
          err: "请填写姓名",
          type: "text",
        },
        {
          label: "职位",
          keyName: "position",
          err: "请填写职位",
          type: "text",
        },
        {
          label: "性别",
          keyName: "sex",
          err: "请填写性别",
          type: "text",
        },
        {
          label: "年龄",
          keyName: "age",
          err: "请填写年龄",
          type: "text",
        },
        {
          label: "生日",
          keyName: "birthday",
          err: "请填写生日",
          type: "text",
        },
        {
          label: "状态",
          keyName: "iswork",
          err: "请填写状态",
          type: "text",
        },
        {
          label: "学历",
          keyName: "education",
          err: "请填写学历",
          type: "text",
        },
        {
          label: "民族",
          keyName: "nationality",
          err: "请填写民族",
          type: "text",
        },
        {
          label: "籍贯",
          keyName: "hometown",
          err: "请填写籍贯",
          type: "text",
        },
        {
          label: "联系方式",
          keyName: "phone",
          err: "请填写联系方式",
          type: "text",
        },
        {
          label: "住址",
          keyName: "address",
          err: "请填写住址",
          type: "text",
        },
        {
          label: "紧急联系人",
          keyName: "contactname",
          err: "请填写紧急联系人",
          type: "text",
        },
        {
          label: "紧急联系人电话",
          keyName: "contactphone",
          err: "请填写紧急联系人电话",
          type: "number",
        },
        {
          label: "身份证正反面",
          keyName: "idcardphoto",
          err: "请填写身份证正反面",
          type: "file",
          viewMode: true,
        },
        {
          label: "驾驶证正反面",
          keyName: "driverlicensephoto",
          err: "请填写驾驶证正反面",
          type: "file",
          viewMode: true,
        },
      ],
      formCtrl2: [
        {
          label: "驾驶员从业资格证正反面",
          keyName: "qualificationcertificatephoto",
          err: "请填写驾驶员从业资格证正反面",
          type: "file",
          viewMode: true,
        },
      ],
    };
  },
  methods: {
    setDetail() {
      const formCtrl = [...this.formCtrl, ...this.formCtrl1, ...this.formCtrl2]
      formCtrl.map(v => {
        const key = v.keyName
        this.form[key] = this.detail[key];
      })
      this.$forceUpdate()
      // console.log({ ...this.detail })
      // console.log({ ...this.form })
    },
    submitReq() {
      this.loading = true
      let url = `${this.baseUrl}/changestate`;
      const params = {
        userid: this.user.id,
      }
      if (this.id) {
        params['id'] = this.id
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  background-color: #fff;
  padding-top: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form-item {
    border-bottom: 1px solid #f2f6fc;
    padding: 0 20px 15px 0;

    .el-input {
      width: 200px;
    }
  }

  // .el-textarea {
  //   width: 200px;
  // }
}

.btns {
  margin: 40px 0 60px 180px;
}
</style>
